import React from "react"
import { Link } from "gatsby"
import axios from "axios"

import arrowRight from "../images/arrow-right.svg"
import filter1 from "../images/filter1.svg"
import filter2 from "../images/filter2.svg"
import filter3 from "../images/filter3.svg"
import shoppingBag from "../images/shape-2.svg"
import arrowUp from "../images/arrow-up.svg"
import arrowUpWhite from "../images/arrow-up-white.svg"
import arrowDown from "../images/arrow-down.svg"
import cartImage from "../images/cartImage.svg"
import phoneImage from "../images/phone.svg"
import guestroLogo from "../images/guestro-full-logo-white.svg"
import shoppingBasket from "../images/shoppingBasket.svg"
import Layout from "../components/layout"
import closeButton from "../images/e-remove.svg"
import { createElement } from "react"
import shoppingBasketWhite from "../images/shopping-basket-white.svg"
import settingsIcon from "../images/setup-preferences.svg"
import smallCheck from "../images/small-check.svg"
import { useCallback } from "react"
import { array } from "prop-types"
import plus from "../images/plus.svg"
function NewlineText(props) {
  const text = props.text;
  const newText = text.split('\r\n').map(str => <p>{str}</p>);
  return newText;
}

function categoryClick(event) {
  event.preventDefault()
  var id = event.target.getAttribute('href');
  var id = id.substring(2);
  document.getElementById(id).scrollIntoView({ behavior: "smooth" })
  var linkCat = document.getElementsByClassName("linkCat")
  var arrowRight = document.getElementsByClassName("arrowRight")
  linkCat = Array.from(linkCat)
  arrowRight = Array.from(arrowRight)
  linkCat.forEach(function (element, index) {
    if (element == event.target) {
      arrowRight[index].classList.add("active")
      linkCat[index].classList.add("active")
    } else {
      arrowRight[index].classList.remove("active")
      linkCat[index].classList.remove("active")
    }
  })
}

function categoryClickModal(event) {
  var linkCat = document.getElementsByClassName("linkCat")
  var arrowRight = document.getElementsByClassName("arrowRight")
  linkCat = Array.from(linkCat)
  arrowRight = Array.from(arrowRight)
  linkCat.forEach(function (element, index) {
    if (element == event.target) {
      arrowRight[index].classList.add("active")
      linkCat[index].classList.add("active")
    } else {
      arrowRight[index].classList.remove("active")
      linkCat[index].classList.remove("active")
    }
  })
}

function clickButtonUp(event) {
  var ups = document.getElementsByClassName("up")
  var numbers = document.getElementsByClassName("quantityValue")
  ups = Array.from(ups)
  numbers = Array.from(numbers)
  ups.forEach(function (element, index) {
    if (element == event.target) {
      var quantity = Number(numbers[index].innerHTML) + 1
      numbers[index].innerHTML = quantity
      numbers[index].style.color = "#e92b5f"
    }
  })
}
function clickButtonDown(event) {
  var downs = document.getElementsByClassName("down")
  var numbers = document.getElementsByClassName("quantityValue")
  downs = Array.from(downs)
  numbers = Array.from(numbers)
  downs.forEach(function (element, index) {
    if (element == event.target && Number(numbers[index].innerHTML) > 0) {
      var quantity = Number(numbers[index].innerHTML) - 1
      numbers[index].innerHTML = quantity
      if (Number(numbers[index].innerHTML) == 0) {
        numbers[index].style.color = "black"
      }
    }
  })
}

//modal button up
function clickButtonUpModal(event) {
  var ups = document.getElementsByClassName("upModal")
  var numbers = document.getElementsByClassName("quantityValueModal")
  ups = Array.from(ups)
  numbers = Array.from(numbers)
  ups.forEach(function (element, index) {
    if (element == event.target) {
      var quantity = Number(numbers[index].innerHTML) + 1
      numbers[index].innerHTML = quantity
      numbers[index].style.color = "#e92b5f"
    }
  })
}
//modal button down
function clickButtonDownModal(event) {
  var downs = document.getElementsByClassName("downModal")
  var numbers = document.getElementsByClassName("quantityValueModal")
  downs = Array.from(downs)
  numbers = Array.from(numbers)
  downs.forEach(function (element, index) {
    if (element == event.target && Number(numbers[index].innerHTML) > 0) {
      var quantity = Number(numbers[index].innerHTML) - 1
      numbers[index].innerHTML = quantity
      if (Number(numbers[index].innerHTML) == 0) {
        numbers[index].style.color = "black"
      }
    }
  })
}
//cart buttons
function clickButtonUpCart(event) {
  var ups = document.getElementsByClassName("upCart")
  var numbers = document.getElementsByClassName("quantityValueCart")
  var priceOfOne = Number(
    event.target.closest(".ItemModal").getElementsByClassName("priceOfOne")[0]
      .value
  )
  var price = event.target
    .closest(".ItemModal")
    .getElementsByClassName("cartModalDishPrice")[0]
    .getElementsByTagName("span")[0]
  var totalPriceCartModal = event.target
    .closest("#cartModal")
    .getElementsByClassName("totalPriceCartModal")[0]
    .getElementsByTagName("span")[0]
  ups = Array.from(ups)
  numbers = Array.from(numbers)
  ups.forEach(function (element, index) {
    if (element == event.target) {
      var quantity = Number(numbers[index].innerHTML) + 1
      totalPriceCartModal.innerHTML =
        Number(
          event.target
            .closest("#cartModal")
            .getElementsByClassName("totalPriceCartModal")[0]
            .getElementsByTagName("span")[0].innerHTML
        ) + priceOfOne
      document
        .getElementsByClassName("mobileTotalPrice")[0]
        .getElementsByTagName("span")[0].innerHTML = Number(
          event.target
            .closest("#cartModal")
            .getElementsByClassName("totalPriceCartModal")[0]
            .getElementsByTagName("span")[0].innerHTML
        )
      price.innerHTML = Number(price.innerHTML) + priceOfOne
      numbers[index].innerHTML = quantity
      numbers[index].style.color = "#e92b5f"
    }
  })
}

function clickButtonDownCart(event) {
  var downs = document.getElementsByClassName("downCart")
  var numbers = document.getElementsByClassName("quantityValueCart")
  var priceOfOne = Number(
    event.target.closest(".ItemModal").getElementsByClassName("priceOfOne")[0]
      .value
  )
  var price = event.target
    .closest(".ItemModal")
    .getElementsByClassName("cartModalDishPrice")[0]
    .getElementsByTagName("span")[0]
  var totalPriceCartModal = event.target
    .closest("#cartModal")
    .getElementsByClassName("totalPriceCartModal")[0]
    .getElementsByTagName("span")[0]
  downs = Array.from(downs)
  numbers = Array.from(numbers)
  downs.forEach(function (element, index) {
    if (element == event.target && Number(numbers[index].innerHTML) > 0) {
      var quantity = Number(numbers[index].innerHTML) - 1
      totalPriceCartModal.innerHTML =
        Number(
          event.target
            .closest("#cartModal")
            .getElementsByClassName("totalPriceCartModal")[0]
            .getElementsByTagName("span")[0].innerHTML
        ) - priceOfOne
      document
        .getElementsByClassName("mobileTotalPrice")[0]
        .getElementsByTagName("span")[0].innerHTML = Number(
          event.target
            .closest("#cartModal")
            .getElementsByClassName("totalPriceCartModal")[0]
            .getElementsByTagName("span")[0].innerHTML
        )
      numbers[index].innerHTML = quantity
      price.innerHTML = Number(price.innerHTML) - priceOfOne
      if (Number(numbers[index].innerHTML) == 0) {
        numbers[index].style.color = "black"
      }
    }
  })
}

//desktop add to cart
function clickAddToCart(event) {
  var buttons = document.getElementsByClassName("button is-danger")
  var numbers = document.getElementsByClassName("quantityValue")
  var food = document.getElementsByClassName("itemCard")
  var addedItems = document.getElementsByClassName("addedItems")[0]
  var item = []
  buttons = Array.from(buttons)
  numbers = Array.from(numbers)
  food = Array.from(food)

  var exists = -1
  buttons.forEach(function (element, index) {
    if (element == event.target) {
      exists = -1
      var newName = event.target
        .closest(".itemCard")
        .getElementsByClassName("dish_name")[0].innerHTML;
      var newSize = 'Standard';
      if (event.target
        .closest(".itemCard")
        .getElementsByClassName("dropdown-trigger")[0] != undefined) {
        newSize = event.target
          .closest(".itemCard")
          .getElementsByClassName("dropdown-trigger")[0]
          .getElementsByTagName("span")[0].innerHTML
      }

      var newQuantity = Number(
        event.target
          .closest(".itemCard")
          .getElementsByClassName("quantityValue")[0].innerHTML
      )
      var inCart = Array.from(document.getElementsByClassName("addedToCart"))
      inCart.forEach(function (elementCart, index) {
        if (
          elementCart.getElementsByClassName("dish_name")[0].innerHTML ==
          newName &&
          elementCart.getElementsByClassName("dish_size")[0].innerHTML ==
          newSize
        ) {
          exists = index
        }
      })
      //no size or no quantity
      var dropdownExists = food[index].getElementsByClassName("dropdown")[0] != undefined;
      console.log(dropdownExists);
      var dropdownSelected = true;
      if (dropdownExists) {
        dropdownSelected = food[index].getElementsByClassName("dropdown")[0].getElementsByClassName('button')[0].getElementsByTagName('span')[0].innerHTML != 'Välj storlek';
        console.log(dropdownSelected);
      }
      if (
        Number(numbers[index].innerHTML) == 0 || dropdownSelected == false
      ) {
        console.log("nothing selected")
      }
      else if (exists != -1) {
        console.log("vec ima u korpi")
        var oldQuantity = Number(
          inCart[exists].getElementsByClassName("cartQuantityInput")[0].value
        )
        console.log(newQuantity)
        inCart[exists].getElementsByClassName("cartQuantityInput")[0].value =
          oldQuantity + newQuantity
        inCart[exists]
          .getElementsByClassName("cartQuantityInput")[0]
          .setAttribute("value", oldQuantity + newQuantity)
        inCart[exists].getElementsByClassName("totalDishPrice")[0].innerHTML =
          Number(inCart[exists].getElementsByClassName("priceOfOne")[0].value) *
          Number(
            inCart[exists].getElementsByClassName("cartQuantityInput")[0].value
          )
        var checkoutTotal = document
          .getElementsByClassName("checkoutTotal")[1]
          .getElementsByTagName("span")[0]
        var prices_in_cart = document.getElementsByClassName("totalDishPrice")
        prices_in_cart = Array.from(prices_in_cart)
        var totalPrice = 0
        prices_in_cart.forEach(function (element, index) {
          totalPrice = totalPrice + Number(element.innerHTML)
        })
        checkoutTotal.innerHTML = totalPrice
      } else {
        item = [
          food[index].getElementsByClassName("dish_name")[0].innerHTML,
          Number(food[index].getElementsByClassName("priceValue")[0].innerHTML),
          Number(
            food[index].getElementsByClassName("quantityValue")[0].innerHTML
          ),
        ]
        var dish_name = food[index].getElementsByClassName("dish_name")[0]
          .innerHTML
        var dish_price = Number(
          food[index].getElementsByClassName("priceValue")[0].innerHTML
          
        )
        var dish_quantity = Number(
          food[index].getElementsByClassName("quantityValue")[0].innerHTML
        )
        var itemId = Number(
          food[index].getElementsByClassName("itemId")[0].innerHTML
        )

        if (!dropdownExists) {
          var dish_size = 'Standard';
        }
        else {
          var dish_size = food[index]
            .getElementsByClassName("dropdown")[0]
            .getElementsByClassName("button")[0]
            .getElementsByTagName("span")[0].innerHTML

        }
        
        var total_dish_price = dish_price * dish_quantity
        addedItems.innerHTML =
          addedItems.innerHTML +
          '<div class="container addedToCart"><div class="columns"><div class="column is-8 has-text-left dish_name">' +
          dish_name +
          '</div><div class="column is-2 has-text-right"><input class="cartQuantityInput" type="number" value="' +
          dish_quantity +
          '"></input><p class="itemId" style="display:none">'+itemId+'</p><input class="priceOfOne" style="display:none" value="' +
          dish_price +
          '"></input></div><div class="columns is-2 has-text-right"><button class="button is-primary deleteButton"><img src=' +
          closeButton +
          '></img></button></div></div><div class="columns"><div class="column is-8 has-text-left dish_size">' +
          dish_size +
          '</div><div class="column is-4 has-text-right"><span class="totalDishPrice">' +
          total_dish_price +
          "</span> kr</div></div></div>"
        document.getElementsByClassName("emptyCart")[0].style.display = "none"
        document.getElementsByClassName("notEmptyCart")[0].style.display =
          "block"

        var checkoutTotal = document
          .getElementsByClassName("checkoutTotal")[1]
          .getElementsByTagName("span")[0]
        var prices_in_cart = document.getElementsByClassName("totalDishPrice")
        prices_in_cart = Array.from(prices_in_cart)
        var totalPrice = 0
        prices_in_cart.forEach(function (element, index) {
          totalPrice = totalPrice + Number(element.innerHTML)
        })
        checkoutTotal.innerHTML = totalPrice
      }
    }
  })
  var deleteButtons = document.getElementsByClassName("deleteButton")
  deleteButtons = Array.from(deleteButtons)
  deleteButtons.forEach(function (element, index) {
    element.addEventListener("click", function (event) {
      if (element == event.target) {
        var toDelete = element.closest(".addedToCart")
        toDelete.remove()

        var afterDeleteButtons = document.getElementsByClassName("deleteButton")
        if (afterDeleteButtons.length == 0) {
          document.getElementsByClassName("emptyCart")[0].style.display =
            "block"
          document.getElementsByClassName("notEmptyCart")[0].style.display =
            "none"
        } else {
          var checkoutTotal = document
            .getElementsByClassName("checkoutTotal")[1]
            .getElementsByTagName("span")[0]
          var prices_in_cart = document.getElementsByClassName("totalDishPrice")
          prices_in_cart = Array.from(prices_in_cart)
          var totalPrice = 0
          prices_in_cart.forEach(function (element, index) {
            totalPrice = totalPrice + Number(element.innerHTML)
          })
          checkoutTotal.innerHTML = totalPrice
        }
      }
    })
  })
  var inputs = document.getElementsByClassName("cartQuantityInput")

  inputs = Array.from(inputs)
  inputs.forEach(function (element, index) {
    element.addEventListener("change", function (event) {
      var priceOfOne = Number(
        event.target
          .closest(".addedToCart")
          .getElementsByClassName("priceOfOne")[0].value
      )
      var newQuantity = Number(event.target.value)
      inputs[index].setAttribute("value", element.value)
      event.target
        .closest(".addedToCart")
        .getElementsByClassName("totalDishPrice")[0].innerHTML =
        priceOfOne * newQuantity
      var checkoutTotal = document
        .getElementsByClassName("checkoutTotal")[1]
        .getElementsByTagName("span")[0]
      var prices_in_cart = document.getElementsByClassName("totalDishPrice")
      prices_in_cart = Array.from(prices_in_cart)
      var totalPrice = 0
      prices_in_cart.forEach(function (element, index) {
        totalPrice = totalPrice + Number(element.innerHTML)
      })
      checkoutTotal.innerHTML = totalPrice
    })
  })
}
//mobile add to cart
function clickAddToCartMobile(event) {
  var cartMobile = document.getElementsByClassName("cartMobile")[0]
  var item = event.target.closest("#itemModalMobile")
  var addedItemsModal = document.getElementsByClassName("addedItemsModal")[0]

  var numberItemsInCart = Number(
    cartMobile.getElementsByClassName("numberItemsInCart")[0].innerHTML
  )

  var dish_name = item.getElementsByClassName("dish_nameModal")[0].innerHTML
  var dish_price = Number(
    item.getElementsByClassName("priceValue")[0].innerHTML
  )
  var itemId = item.getElementsByClassName('itemIdModal')[0].innerHTML
  var dish_quantity = item.getElementsByClassName("quantityValueModal")[0]
    .innerHTML;
    
  var dish_total_price = Number(dish_price) * Number(dish_quantity)
  var radios = event.target
    .closest(".modal-content")
    .getElementsByClassName("radio")
  radios = Array.from(radios)
  var dish_size = null

  radios.forEach(function (element, index) {
    if (radios[index].getElementsByTagName("input")[0].checked == true) {
      dish_size = radios[index].getElementsByTagName("label")[0].innerHTML
    }
  })
  var inCart = Array.from(document.getElementsByClassName("ItemModal"))
  var exists = -1
  inCart.forEach(function (element, index) {

    if (
      element.getElementsByClassName("cartModalDishName")[0].innerHTML ==
      dish_name &&
      element.getElementsByClassName("cartModalDishDescription")[0].innerHTML ==
      dish_size
    ) {
      exists = index
    }
  })
  var radiosExist = document.getElementsByClassName('radioSizeButtons')[0].style.display != 'none';

  if (dish_quantity == 0) {
    console.log("nothing sleceted")
  } else if (radiosExist && dish_size == null) {
    console.log('posotji ali nije select');
  }
  else if (exists != -1) {
    console.log("same item")
  } else {
    if (!radiosExist) {
      dish_size = 'Standard';
    }
    document.getElementsByClassName("categoriesMobile")[0].style.bottom = "5rem"
    cartMobile.style.display = "flex"
    cartMobile.getElementsByClassName("numberItemsInCart")[0].innerHTML =
      numberItemsInCart + 1
    addedItemsModal.innerHTML =
      addedItemsModal.innerHTML +
      '<div class="column ItemModal"> <div class="columns"> <div class="column dishNameColumn"> <p class="cartModalDishName">' +
      dish_name +
      '</p> </div> <div class="column dish_descriptionColumn"> <p class="cartModalDishDescription">' +
      dish_size +
      '</p> </div> <div class="column"> <div class="columns is-mobile"> <div class="column"> <div class="columns quantityColumnCart"> <div class="column is-4 btnDownCart"> <button class="button downCart" > <img src=' +
      arrowDown +
      ' alt="Arrow Down"></img> </button> </div> <div class="column is-4 quantityCart"> <p class="quantityValueCart">' +
      dish_quantity +
      '</p> </div> <div class="column is-4 btnUpCart"> <button class="button upCart" > <img src=' +
      arrowUp +
      ' alt="Arrow Up"></img> </button> </div> </div> </div> <div class="column is-2"> <p class="cartModalDishPrice"><span>' +
      dish_total_price +
      '</span> kr</p> </div> <p class="itemId" style="display:none">'+itemId+'</p><div class="column is-2"> <input class="priceOfOne" style="display:none" value="' +
      dish_price +
      '"><button class="button is-primary deleteButtonModal"> <img src=' +
      closeButton +
      "></img> </button> </div> </div> </div> </div> </div>"
    document
      .getElementsByClassName("mobileTotalPrice")[0]
      .getElementsByTagName("span")[0].innerHTML =
      Number(
        document
          .getElementsByClassName("mobileTotalPrice")[0]
          .getElementsByTagName("span")[0].innerHTML
      ) + dish_total_price
    document
      .getElementsByClassName("totalPriceCartModal")[0]
      .getElementsByTagName("span")[0].innerHTML =
      Number(
        document
          .getElementsByClassName("totalPriceCartModal")[0]
          .getElementsByTagName("span")[0].innerHTML
      ) + dish_total_price
    var ups = document
      .getElementsByClassName("addedItemsModal")[0]
      .getElementsByClassName("btnUpCart")
    var downs = document
      .getElementsByClassName("addedItemsModal")[0]
      .getElementsByClassName("btnDownCart")
    var closes = document
      .getElementsByClassName("addedItemsModal")[0]
      .getElementsByClassName("deleteButtonModal")
    ups = Array.from(ups)
    downs = Array.from(downs)
    closes = Array.from(closes)
    ups.forEach(function (element, index) {
      ups[index].addEventListener("click", function (event) {
        clickButtonUpCart(event)
      })
    })
    downs.forEach(function (element, index) {
      downs[index].addEventListener("click", function (event) {
        clickButtonDownCart(event)
      })
    })
    closes.forEach(function (element, index) {
      closes[index].addEventListener("click", function (event) {
        var toReduce = Number(
          closes[index]
            .closest(".ItemModal")
            .getElementsByClassName("cartModalDishPrice")[0]
            .getElementsByTagName("span")[0].innerHTML
        )
        document
          .getElementsByClassName("mobileTotalPrice")[0]
          .getElementsByTagName("span")[0].innerHTML =
          Number(
            document
              .getElementsByClassName("mobileTotalPrice")[0]
              .getElementsByTagName("span")[0].innerHTML
          ) - toReduce
        document
          .getElementsByClassName("totalPriceCartModal")[0]
          .getElementsByTagName("span")[0].innerHTML =
          Number(
            document
              .getElementsByClassName("totalPriceCartModal")[0]
              .getElementsByTagName("span")[0].innerHTML
          ) - toReduce
        closes[index].closest(".ItemModal").remove()
        document.getElementsByClassName("numberItemsInCart")[0].innerHTML =
          Number(
            document.getElementsByClassName("numberItemsInCart")[0].innerHTML
          ) - 1
        if (document.getElementsByClassName("ItemModal").length == 0) {
          document.getElementsByClassName("cartMobile")[0].style.display =
            "none"
          document.getElementsByClassName("categoriesMobile")[0].style.bottom =
            "1rem"
          document.getElementById("cartModal").classList.remove("is-active")
        }
      })
    })
  }
  event.target.closest('#itemModalMobile').classList.toggle('is-active');

}
function openCartModal(event) {
  document.getElementById("cartModal").classList.add("is-active")
}
function closeCartModal(event) {
  document.getElementById("cartModal").classList.remove("is-active")
}
function openCategoriesModal(event) {
  document.getElementById("categoriesModal").classList.add("is-active")
}
function closeCategoriesModal(event) {
  document.getElementById("categoriesModal").classList.remove("is-active")
}
function openCategoriesInModal(event) {
  if (
    document.getElementsByClassName("categoriesHidden")[0].style.display ==
    "grid"
  ) {
    document.getElementsByClassName("categoriesHidden")[0].style.display =
      "none"
    event.target.style.backgroundColor = "white"
  } else {
    document.getElementsByClassName("categoriesHidden")[0].style.display =
      "grid"
    event.target.style.backgroundColor = "#f9f9f9"
  }
}
/*
function openDietaryInModal(event) {
  if (
    document.getElementsByClassName("dietaryHidden")[0].style.display == "grid"
  ) {
    document.getElementsByClassName("dietaryHidden")[0].style.display = "none"
    event.target.style.backgroundColor = "white"
  } else {
    document.getElementsByClassName("dietaryHidden")[0].style.display = "grid"
    event.target.style.backgroundColor = "#f9f9f9"
  }
}*/
function openItemModal(event) {
  if (window.innerWidth < 1024) {
    var itemModalMobile = document.getElementById("itemModalMobile")
    var dish_name = event.target.getElementsByClassName("dish_name")[0]
    var dish_price = event.target.getElementsByClassName("price")[0]
    var dish_description = event.target.getElementsByClassName(
      "dish_description"
    )[0]
    var dish_id = event.target.getElementsByClassName('itemId')[0].innerHTML;
    console.log(dish_id);
    var dish_image = event.target.getElementsByClassName(
      "image is-hidden-desktop"
    )[0]
    
    //console.log(event.target.getElementsByClassName('bottomContainer')[0]);
    var radio1 = event.target.getElementsByClassName('bottomContainer')[0].getElementsByClassName('radio1')[0];
    var radio2 = event.target.getElementsByClassName('bottomContainer')[0].getElementsByClassName('radio2')[0];
    var radio3 = event.target.getElementsByClassName('bottomContainer')[0].getElementsByClassName('radio3')[0];
    if (radio1 == undefined && radio2 == undefined && radio3 == undefined) {
      itemModalMobile.getElementsByClassName('radioSizeButtons')[0].style.display = "none";
    }
    else {
      itemModalMobile.getElementsByClassName('radioSizeButtons')[0].style.display = "block";
    }
    if (radio2 != undefined && radio3 != undefined) {
      itemModalMobile.getElementsByClassName('radioSizeButtons')[0].innerHTML = '<a class="selectItem"> <div class="radio radio1"> <input id="radio-1" name="radio" type="radio" ></input> <label for="radio-1" class="radio-label" > Standard </label> <span class="addPrice"> ' + dish_price.getElementsByTagName('span')[0].innerHTML + '</span></div> </a>' + '<a class="selectItem" onClick={clickDropdownItem.bind( this )} > <div class="radio radio2"> <input id="radio-2" name="radio" type="radio" ></input> <label for="radio-2" class="radio-label" > Mellan </label> <span class="addPrice"> ' + radio2.getElementsByClassName('addPrice')[0].innerHTML + '</span> </div> </a>' + '<a class="selectItem" onClick={clickDropdownItem.bind( this )} > <div class="radio radio3"> <input id="radio-3" name="radio" type="radio" ></input> <label for="radio-3" class="radio-label" > Stor </label> <span class="addPrice"> ' + radio3.getElementsByClassName('addPrice')[0].innerHTML + '</span> </div> </a>';

    }
    if (radio2 != undefined && radio3 == undefined) {
      itemModalMobile.getElementsByClassName('radioSizeButtons')[0].innerHTML = '<a class="selectItem"> <div class="radio radio1"> <input id="radio-1" name="radio" type="radio" ></input> <label for="radio-1" class="radio-label" > Standard </label> <span class="addPrice"> ' + dish_price.getElementsByTagName('span')[0].innerHTML + '</span> </div> </a>' + '<a class="selectItem" onClick={clickDropdownItem.bind( this )} > <div class="radio radio2"> <input id="radio-2" name="radio" type="radio" ></input> <label for="radio-2" class="radio-label" > Mellan </label> <span class="addPrice"> ' + radio2.getElementsByClassName('addPrice')[0].innerHTML + '</span> </div> </a>';
    }
    if (radio2 == undefined && radio3 != undefined) {
      itemModalMobile.getElementsByClassName('radioSizeButtons')[0].innerHTML = '<a class="selectItem"> <div class="radio radio1"> <input id="radio-1" name="radio" type="radio" ></input> <label for="radio-1" class="radio-label" > Standard </label> <span class ="addPrice"> ' + dish_price.getElementsByTagName('span')[0].innerHTML + '</span> </div> </a>' + '<a class="selectItem" onClick={clickDropdownItem.bind( this )} > <div class="radio radio3"> <input id="radio-3" name="radio" type="radio" ></input> <label for="radio-3" class="radio-label" > Stor </label> <span class="addPrice"> ' + radio3.getElementsByClassName('addPrice')[0].innerHTML + '</span> </div> </a>';
    }
    itemModalMobile.getElementsByClassName("dish_nameModal")[0].innerHTML =
      dish_name.innerHTML
    itemModalMobile.getElementsByClassName("dish_priceModal")[0].innerHTML =
      dish_price.innerHTML
    itemModalMobile.getElementsByClassName(
      "dish_descriptionModal"
    )[0].innerHTML = dish_description.innerHTML
    itemModalMobile.getElementsByClassName('itemIdModal')[0].innerHTML=dish_id;

    if (dish_image != undefined) {
      itemModalMobile.getElementsByClassName("dish_image")[0].innerHTML =
        dish_image.innerHTML
      itemModalMobile.getElementsByClassName("dish_image")[0].style.display =
        "block"
      itemModalMobile.getElementsByClassName(
        "dish_priceModal"
      )[0].style.marginRight = "0rem"
    } else {
      itemModalMobile.getElementsByClassName("dish_image")[0].style.display =
        "none"
      itemModalMobile.getElementsByClassName(
        "dish_priceModal"
      )[0].style.marginRight = "2.5rem"
    }

    itemModalMobile.getElementsByClassName("quantityValueModal")[0].innerHTML =
      "0"
    itemModalMobile.getElementsByClassName(
      "quantityValueModal"
    )[0].style.color = "black"
    document.getElementById("itemModalMobile").classList.add("is-active")

    var radios = Array.from(itemModalMobile.getElementsByClassName('radio'));
    radios.forEach(function (element, index) {
      radios[index].addEventListener('click', function (event) {
        console.log("click");
        modalSizeClick(event);
      })
    })
  }
}
function closeItemModal(event) {
  document.getElementById("itemModalMobile").classList.remove("is-active")
}
function clickDropdown(event) {
  if (event.target.closest(".dropdown").classList.contains("is-active")) {
    event.target.closest(".dropdown").classList.remove("is-active")
  } else {
    event.target.closest(".dropdown").classList.add("is-active")
  }
}
function clickDropdownItem(event) {
  event.target
    .closest(".itemCard")
    .getElementsByClassName("priceValue")[0].innerHTML = Number(
      event.target.getElementsByClassName("addPrice")[0].innerHTML
    )

  event.target.getElementsByTagName("input")[0].checked = true
  event.target
    .closest(".dropdown")
    .getElementsByClassName("button")[0]
    .getElementsByTagName(
      "span"
    )[0].innerHTML = event.target.getElementsByTagName("label")[0].innerHTML
  var radios = Array.from(
    event.target.closest(".dropdown").getElementsByTagName("input")
  )
  var items = Array.from(
    event.target.closest(".dropdown").getElementsByClassName("dropdown-item")
  )
  radios.forEach(function (element, index) {
    radios[index].checked = false
    items[index].style.color = "#949494"
    items[index].style.backgroundColor = "transparent"
    items[index].style.fontWeight = "500"
  })
  event.target.getElementsByTagName("input")[0].checked = true
  event.target.style.color = "#1f4d68"
  event.target.style.fontWeight = "700"
  event.target.style.backgroundColor = "#f9f9f9"
  event.target.closest(".dropdown").classList.remove("is-active")
  event.target
    .closest(".dropdown")
    .getElementsByClassName("button")[0].style.backgroundColor = "#e1144e"
  event.target
    .closest(".dropdown")
    .getElementsByClassName("button")[0].style.border = "1px solid #e1144e"
  event.target
    .closest(".dropdown")
    .getElementsByClassName("button")[0].style.color = "white"
  event.target
    .closest(".dropdown")
    .getElementsByClassName("button")[0]
    .getElementsByTagName("path")[0].style.fill = "#ffffff"
}
function modalSizeClick(event) {
  document.getElementsByClassName('dish_priceModal')[0].getElementsByClassName('priceValue')[0].innerHTML = event.target.closest('.radio').getElementsByClassName('addPrice')[0].innerHTML;

  var selectItem = event.target.closest(".selectItem")
  var selectItems = Array.from(
    selectItem.closest(".column").getElementsByClassName("selectItem")
  )
  selectItems.forEach(function (element, index) {
    selectItems[index].getElementsByTagName("label")[0].style.color = "#949494"
    selectItems[index].getElementsByTagName("label")[0].style.fontWeight = "400"
    selectItems[index].getElementsByClassName("addPrice")[0].style.color =
      "#949494"
    selectItems[index].getElementsByClassName("addPrice")[0].style.fontWeight =
      "400"
  })
  selectItem.getElementsByTagName("label")[0].style.color = "#1f4d68"
  selectItem.getElementsByTagName("label")[0].style.fontWeight = "700"
  selectItem.getElementsByClassName("addPrice")[0].style.color = "#1f4d68"
  selectItem.getElementsByClassName("addPrice")[0].style.fontWeight = "700"
}

function goToCheckOutClick(event) {
  //into local storage
  var array = []
  var cart = event.target.closest(".notEmptyCart")
  var items = Array.from(cart.getElementsByClassName("addedToCart"))
  items.forEach(function (element, index) {
    var name = element.getElementsByClassName("has-text-left")[0].innerHTML
    var price = element.getElementsByClassName("totalDishPrice")[0].innerHTML
    var size = element.getElementsByClassName("dish_size")[0].innerHTML
    var quantity = element.getElementsByClassName('cartQuantityInput')[0].value;
    var id = element.getElementsByClassName('itemId')[0].innerHTML;
    var newArray = [name, price, size, quantity, id]
    array.push(newArray)
  })
  var total = document
    .getElementsByClassName("notEmptyCart")[0]
    .getElementsByClassName("checkoutTotal")[1]
    .getElementsByTagName("span")[0].innerHTML
  localStorage.setItem("cart", JSON.stringify(array))
  localStorage.setItem("cartTotal", total)
  window.open("/checkout/", "_self")
}

function goToCheckOutClickModal(event) {
  var array = []
  var cart = event.target
    .closest(".modal-content")
    .getElementsByClassName("addedItemsModal")[0]
  console.log(cart)
  var items = Array.from(cart.getElementsByClassName("ItemModal"))
  items.forEach(function (element, index) {
    var name = element.getElementsByClassName("cartModalDishName")[0].innerHTML
    var size = element.getElementsByClassName("cartModalDishDescription")[0]
      .innerHTML
    var price = element
      .getElementsByClassName("cartModalDishPrice")[0]
      .getElementsByTagName("span")[0].innerHTML;
      var quantity = element.getElementsByClassName('quantityValueCart')[0].innerHTML;
      var id = element.getElementsByClassName('itemId')[0].innerHTML;
    var newArray = [name, price, size, quantity, id]
    array.push(newArray)
  })
  var total = document
    .getElementsByClassName("totalPriceCartModal")[0]
    .getElementsByTagName("span")[0].innerHTML
  localStorage.setItem("cart", JSON.stringify(array))
  localStorage.setItem("cartTotal", total)
  window.open("/checkout/", "_self")
}

export default class IndexPage extends React.Component {
  state = {
    categories: [],
    menu: [],
    cart: [],
    fullMenu: [],
    test: [],
    restaurantEmail:'',
    restaurantPhone:'',
    restaurantLogo:'',
    restaurantName:'',
  }
  componentDidMount() {
    // full menu
    axios.get(`https://app.guestro.se/api/profiles/24/`).then(res => {
      //console.log(res.data.data);
      const restaurantInformation = res.data.data;
      this.setState({ restaurantEmail: restaurantInformation.email, restaurantPhone: restaurantInformation.phone}, function () {
        localStorage.setItem('restaurantBcg', restaurantInformation.image.full)
        localStorage.setItem('restaurantLogo', restaurantInformation.logo);
        localStorage.setItem('restaurantPhone', restaurantInformation.phone);
        localStorage.setItem('restaurantEmail', restaurantInformation.email);
        localStorage.setItem('restaurantName', restaurantInformation.name);
        localStorage.setItem('restaurantId', restaurantInformation.id);
        localStorage.setItem('hours', JSON.stringify(restaurantInformation.working_time));
        console.log(localStorage.getItem('hours'));
      })
    })
    axios.get(`https://app.guestro.se/api/profiles/24/menus/`).then(res => {
      const fullMenu = res.data.data;
      this.setState({ fullMenu: fullMenu }, function () {
      })
    })
    // ordering menu
    axios
      .get(
        `https://app.guestro.se/api/v2/order_menu/24/`
      )
      .then(res => {
        var category = []
        const menu = res.data.data
        this.setState({ menu: menu }, function () {
          var menu = Array.from(this.state.menu)
          menu.forEach(function (menuElement, index) {
            var contains = false
            category.forEach(function (categoryElement, index) {
              if (categoryElement == menuElement.category_name) {
                contains = true;
              }
            })
            if (!contains && menuElement.category_name != null) {
              category.push(menuElement.category_name)
            }
          })
          this.setState({ categories: category }, function () {
          })
        })
      })
  }
  render() {
    return (
      <Layout>
        <div class="modal" id="categoriesModal">
          <div class="modal-background"></div>
          <div class="modal-content">
            <figure>
              <img src={settingsIcon} alt=""></img>
              <p className="categoriesAndDietary">Menyer</p>
              <button
                class="modal-close is-large"
                aria-label="close"
                onClick={closeCategoriesModal.bind(this)}
              ></button>
            </figure>
            <div class="columns">
              <div class="column is-12">
                <button
                  class="button categoriesButton"
                  onClick={openCategoriesInModal.bind(this)}
                >
                  <p>Menyer</p>
                  <figure>
                    <img src={arrowDown} alt="" />
                  </figure>
                </button>
              </div>
              <div class="column is-10 categoriesHidden">
                <div class="columns is-mobile is-multiline">
                  <div class="column is-6">
                    <div class="columns is-mobile">
                      <div class="column is-9 has-text-left">
                        <Link
                          to={`#${this.state.categories[0]}`}
                          onClick={categoryClickModal.bind(this)}
                          className="linkCat active"
                        >
                          Visa alla
                        </Link>
                      </div>
                      <div class="column is-2 has-text-right">
                        <img
                          src={smallCheck}
                          alt="Right Arrow"
                          className="arrowRight active"
                        />
                      </div>
                    </div>
                  </div>

                  {this.state.categories.map(category => (
                    <div class="column is-6">
                      <div class="columns is-mobile">
                        <div class="column is-9 has-text-left">
                          <Link
                            to={`#${category}`}
                            //href={'#' + category}
                            onClick={categoryClickModal.bind(this)}
                            className="linkCat"
                          >
                            {category[0].toUpperCase() + category.slice(1).toLowerCase()}
                          </Link>
                        </div>
                        <div class="column is-2 has-text-right">
                          <img
                            src={smallCheck}
                            alt="Right Arrow"
                            className="arrowRight"
                          ></img>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/*
              <div class="column is-12">
                <button
                  class="button dietaryButton"
                  onClick={openDietaryInModal.bind(this)}
                >
                  <p>Specialkost</p>
                  <figure>
                    <img src={arrowDown} alt="" />
                  </figure>
                </button>
              </div>
              <div class="column is-10 dietaryHidden">
                <div class="columns is-mobile is-multiline">
                  <div class="column is-6">
                    <figure>
                      <img src={filter1} alt="" />
                      <p>Filter 1</p>
                    </figure>
                  </div>
                  <div class="column is-6">
                    <figure>
                      <img src={filter2} alt="" />
                      <p>Filter 2</p>
                    </figure>
                  </div>
                  <div class="column is-6">
                    <figure>
                      <img src={filter3} alt="" />
                      <p>Filter 3</p>
                    </figure>
                  </div>
                  <div class="column is-6">
                    <figure>
                      <img src={filter1} alt="" />
                      <p>Filter 4</p>
                    </figure>
                  </div>
                  <div class="column is-6">
                    <figure>
                      <img src={filter2} alt="" />
                      <p>Filter 5</p>
                    </figure>
                  </div>
                  <div class="column is-6">
                    <figure>
                      <img src={filter3} alt="" />
                      <p>Filter 6</p>
                    </figure>
                  </div>
                </div>
              </div>
            */}
            </div>
            <div class="columns is-mobile applyClearButtons">
              <div class="column has-text-left">
                <button className="button clearButton">Rensa val</button>
              </div>
              <div class="column has-text-right">
                <button className="button applyButton">Lägg till</button>
              </div>
            </div>
          </div>
        </div>

        <button
          className="button categoriesMobile is-hidden-desktop"
          onClick={openCategoriesModal.bind(this)}
        >
          <figure>
            <img src={settingsIcon} alt=""></img>
            <p>MENYER</p>
          </figure>
        </button>

        <div class="modal" id="cartModal">
          <div class="modal-background"></div>
          <div class="modal-content">
            <figure>
              <img src={shoppingBasket} alt=""></img>
              <p className="yourCartText">Din varukorg</p>
            </figure>
            <button
              class="modal-close is-large"
              aria-label="close"
              onClick={closeCartModal.bind(this)}
            ></button>
            <hr></hr>
            <div class="columns addedItemsModal"></div>
            <hr></hr>
            <div class="columns is-mobile bottomColumn">
              <div class="column totalCartModal">
                <p className="totalPriceCartModal">
                  <span>0</span><span> kr</span> 
                </p>
                <p className="foodTotalText">TOTALT</p>
              </div>
              <div class="column">
                <Link
                  className="button is-secondary"
                  onClick={goToCheckOutClickModal.bind(this)}
                >
                  Gå vidare
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          className="button cartMobile is-hidden-desktop"
          onClick={openCartModal.bind(this)}
        >
          <div className="columns is-mobile">
            <div className="column is-2">
              <figure>
                <img src={shoppingBasketWhite} alt=""></img>
              </figure>
            </div>
            <div className="column is-6 has-text-left">
              <p>Din varukorg</p>
              <p>
                <span className="numberItemsInCart">0</span> valda produkter
              </p>
            </div>
            <div className="column is-4 has-text-right">
              <p className="mobileTotalPrice">
                <span>0</span> <span> kr</span> 
                <img src={arrowUpWhite}></img>
              </p>
            </div>
          </div>
        </button>

        <section className="section main__section">
          <div className="container main_container">
            <div className="columns">
              <div className="column is-2 categoriesColumn is-hidden-touch">
                {/* 
                <div class="dropdown dietaryOptions">
                  <div class="dropdown-trigger">
                    <button
                      class="button"
                      aria-haspopup="true"
                      aria-controls="dropdown-menu"
                      onClick={clickDropdown.bind(this)}
                    >
                      <span>Specialkost</span>
                      <span class="icon is-small">
                        <img src={arrowDown} alt="" />
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <figure>
                            <img src={filter1} alt="" />
                            <p>Filter 1</p>
                          </figure>
                        </div>
                        <div class="column is-6">
                          <figure>
                            <img src={filter2} alt="" />
                            <p>Filter 2</p>
                          </figure>
                        </div>
                        <div class="column is-6">
                          <figure>
                            <img src={filter3} alt="" />
                            <p>Filter 3</p>
                          </figure>
                        </div>

                        <div class="column is-6">
                          <figure>
                            <img src={filter3} alt="" />
                            <p>Filter 4</p>
                          </figure>
                        </div>

                        <div class="column is-6">
                          <figure>
                            <img src={filter2} alt="" />
                            <p>Filter 5</p>
                          </figure>
                        </div>

                        <div class="column is-6">
                          <figure>
                            <img src={filter1} alt="" />
                            <p>Filter 6</p>
                          </figure>
                        </div>

                        <div class="column is-6">
                          <figure>
                            <img src={filter3} alt="" />
                            <p>Filter 7</p>
                          </figure>
                        </div>
                      </div>
                      <div class="columns is-multiline">
                        <div class="column">
                          <button className="button clearButton">
                            Rensa val
                          </button>
                        </div>
                        <div class="column">
                          <button className="button applyButton">
                            Lägg till
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
*/}
                <p className="titleCat">MENYER</p>
                <div className="container">
                  <div className="columns">
                    <div className="column is-12 categoriesToFill">
                      <div class="columns">
                        <div class="column is-10 has-text-left">
                          <Link
                            to={`#${this.state.categories[0]}`}
                            onClick={categoryClick.bind(this)}
                            className="linkCat active"
                          >
                            Visa alla
                          </Link>
                        </div>
                        <div class="column is-2 has-text-right">
                          <img
                            src={arrowRight}
                            alt="Right Arrow"
                            className="arrowRight active"
                          ></img>
                        </div>
                      </div>

                      {this.state.categories.map(category => (
                        <div class="columns">
                          <div class="column is-10 has-text-left">
                            <Link
                              className="linkCat"
                              onClick={categoryClick.bind(this)}
                              to={`#${category}`}
                            >
                              {category[0].toUpperCase() + category.slice(1).toLowerCase()}
                            </Link>
                          </div>
                          <div class="column is-2 has-text-right">
                            <img
                              src={arrowRight}
                              alt="Right Arrow"
                              className="arrowRight"
                            ></img>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="column is-7 menuColumn">
                <p className="mainTitle">Beställ från oss</p>
                <p className="mainSubtitle">
                  Fyll i fälten nedan, välj vilka produkter och antal du vill
                  beställa.
                </p>

                <div class="modal" id="itemModalMobile">
                  <div class="modal-background"></div>
                  <div class="modal-content">
                    <button
                      class="modal-close is-large"
                      aria-label="close"
                      onClick={closeItemModal.bind(this)}
                    ></button>
                    <div class="columns">
                      <div class="column imageColumnMobile">
                        <figure className="dish_image">
                          <img src={arrowRight} alt=""></img>
                        </figure>
                      </div>
                    </div>
                    <div class="columns is-mobile">
                      <div class="column">
                        <p className="dish_nameModal">Petit Plateu</p>
                      </div>
                      <div class="column has-text-right">
                        <p>
                          <span className="dish_priceModal">78.34</span>
                          <p className = 'itemIdModal'>12</p>
                        </p>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <p className="dish_descriptionModal">
                          150g Slow-cooked, premium beef, potatoes, and carrots,
                          served in a rich gravy. Served with dinner roll.
                        </p>
                      </div>
                    </div>
                    <div class="columns radioSizeButtons">
                      <p className="selectSize">Välj storlek</p>
                      <div class="column">

                      </div>
                    </div>
                    <div class="columns is-mobile buttonsColumns">
                      <div class="column">
                        <div className="columns quantityColumnModal">
                          <div className="column is-4 btnDownModal">
                            <button
                              className="button downModal"
                              onClick={clickButtonDownModal.bind(this)}
                            >
                              <img src={arrowDown} alt="Arrow Down"></img>
                            </button>
                          </div>
                          <div className="column is-4 quantityModal">
                            <p className="quantityValueModal">0</p>
                          </div>
                          <div className="column is-4 btnUpModal">
                            <button
                              className="button upModal"
                              onClick={clickButtonUpModal.bind(this)}
                            >
                              <img src={arrowUp} alt="Arrow Up"></img>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="column buttonsColumn">
                        <button
                          className="button is-dangerModal"
                          onClick={clickAddToCartMobile.bind(this)}
                        >
                          <figure className="shoppingIcon">
                            <img src={shoppingBag} alt="Shopping Bag"></img>
                          </figure>
                          Lägg till
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.categories.map(category => (
                  <div id={category} className="cat__section">
                    <p className="mainCategoryTitle">
                      {category[0].toUpperCase() + category.slice(1).toLowerCase()}
                    </p>
                    {this.state.menu.map(item =>
                      item.category_name == category ? (
                        <div className="container">
                          <div className="columns">
                            <div
                              className="column itemCard"
                              onClick={openItemModal.bind(this)}
                            >
                              <div className="container inner_container">
                              <img src={plus} className="plusImage is-hidden-desktop"></img>

                                <div className="columns">

                                  {this.state.fullMenu.map(fullMenuItem =>
                                    <>
                                      {
                                        fullMenuItem.categories.map(category =>
                                          <>
                                            {
                                              category.items.map(itemfull =>
                                                <>{itemfull.id == item.item_id && itemfull.image.full != ''
                                                  ? <div className="column is-3 foodImage">
                                                    <figure className="image is-square is-hidden-touch">
                                                      <></>
                                                      <img
                                                        src={itemfull.image.full}
                                                        alt="Food image"
                                                      ></img>
                                                    </figure>
                                                    <figure className="image is-hidden-desktop">
                                                      <img
                                                        src={itemfull.image.full}
                                                        alt="Food image"
                                                      ></img>
                                                    </figure>
                                                  </div>
                                                  : <></>
                                                }
                                                </>
                                              )
                                            }
                                          </>
                                        )
                                      }
                                    </>
                                  )}


                                  {/** 
                                {this.state.fullMenu.map(fullMenuItem =>
                                
                                fullMenuItem.id == item.id ?(
                                  fullMenuItem.image.full != '' && fullMenuItem.image.full != undefined
                                  ? (
                                    <div className="column is-3 foodImage">
                                        <figure className="image is-square is-hidden-touch">
                                          <img
                                            src={fullMenuItem.image.full}
                                            alt="Food image"
                                          ></img>
                                        </figure>
                                        <figure className="image is-hidden-desktop">
                                          <img
                                            src={fullMenuItem.image.full}
                                            alt="Food image"
                                          ></img>
                                        </figure>
                                      </div>
                                  )
                             :(                           
                              <></>      
                              )
                                )
                             : <></>
                                )}
*/}
                                  {/** 
                                  {item.image != "" &&
                                    item.image != undefined ? (
                                      <div className="column is-3 foodImage">
                                        <figure className="image is-square is-hidden-touch">
                                          <img
                                            src={item.image}
                                            alt="Food image"
                                          ></img>
                                        </figure>
                                        <figure className="image is-hidden-desktop">
                                          <img
                                            src={item.image}
                                            alt="Food image"
                                          ></img>
                                        </figure>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
*/}
                                  <div className="column">
                                    <div className="container inner_container">
                                      <div className="columns is-mobile namePriceColumns">
                                        <div className="column is-10">
                                          <p className="dish_name">
                                            {item.name}
                                          </p>
                                        </div>
                                        <p className="itemId">{item.id}</p>
                                        <div className="column is-2 priceColumn">
                                          <p className="price">
                                            <span className="priceValue">
                                              {item.price}
                                            </span>
                                            <span> kr</span> 
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    {/** 
                                <div className="container inner_container">
                                  <div className="columns">
                                    <div className="column is-12 filtersColumn">
                                      <img
                                        src={filter1}
                                        className="filterIcon"
                                        name="Hover"
                                        alt="Filter 1"
                                      ></img>
                                      <img
                                        src={filter2}
                                        className="filterIcon"
                                        alt="Filter 1"
                                      ></img>
                                      <img
                                        src={filter3}
                                        className="filterIcon"
                                        alt="Filter 1"
                                      ></img>
                                    </div>
                                  </div>
                                </div>
                                */}
                                    <div className="container inner_container">
                                      <div className="columns">
                                        <div className="column is-12 descriptionColumn">
                                          <p className="dish_description">
                                            <NewlineText text={item.description}></NewlineText>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="container inner_container bottomContainer is-hidden-touch">
                                      <div className="columns">
                                        <div className="column is-3">
                                          <div className="container">
                                            <div className="columns quantityColumn">
                                              <div className="column is-4 btnDown">
                                                <button
                                                  className="button down"
                                                  onClick={clickButtonDown.bind(
                                                    this
                                                  )}
                                                >
                                                  <img
                                                    src={arrowDown}
                                                    alt="Arrow Down"
                                                  ></img>
                                                </button>
                                              </div>
                                              <div className="column is-4 quantity">
                                                <p className="quantityValue">
                                                  0
                                                </p>
                                              </div>
                                              <div className="column is-4 btnUp">
                                                <button
                                                  className="button up"
                                                  onClick={clickButtonUp.bind(
                                                    this
                                                  )}
                                                >
                                                  <img
                                                    src={arrowUp}
                                                    alt="Arrow Up"
                                                  ></img>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="column is-3">
                                          {/**no medium no large dont display size select */}
                                          {item.large_price == null &&
                                            item.medium_price == null ? (
                                              <></>
                                            ) : (
                                              <div class="dropdown">
                                                <div class="dropdown-trigger">
                                                  <button
                                                    onClick={clickDropdown.bind(
                                                      this
                                                    )}
                                                    class="button"
                                                    aria-haspopup="true"
                                                    aria-controls="dropdown-menu"
                                                  >
                                                    <span>Välj storlek</span>
                                                    <span class="icon is-small">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="10"
                                                        height="6"
                                                        viewBox="0 0 10 6"
                                                      >
                                                        <path
                                                          fill="#1E1D24"
                                                          d="M8.704 6L5 2.471 1.296 6 0 4.765 5 0 10 4.765z"
                                                          transform="matrix(1 0 0 -1 0 6)"
                                                        />
                                                      </svg>
                                                    </span>
                                                  </button>
                                                </div>
                                                <div
                                                  class="dropdown-menu"
                                                  id="dropdown-menu"
                                                  role="menu"
                                                >
                                                  <div class="dropdown-content">
                                                    
                                                    {/**if there is only medium display large and small*/}
                                                    {/** small*/}

                                                    {item.medium_price == null ? (
                                                      <a
                                                        class="dropdown-item"
                                                        onClick={clickDropdownItem.bind(
                                                          this
                                                        )}
                                                      >
                                                        <div class="radio radio1">
                                                          <input
                                                            id="radio-1"
                                                            name="radio"
                                                            type="radio"
                                                          ></input>
                                                          <label
                                                            for="radio-1"
                                                            class="radio-label"
                                                          >
                                                            Standard
                                                        </label>
                                                          <span className="addPrice">
                                                            {item.price}
                                                          </span>
                                                        </div>
                                                      </a>
                                                    ) : (
                                                        <></>
                                                      )}
                                                    {/** large*/}

                                                    {item.medium_price == null ? (
                                                      <a
                                                        class="dropdown-item"
                                                        onClick={clickDropdownItem.bind(
                                                          this
                                                        )}
                                                      >
                                                        <div class="radio radio2">
                                                          <input
                                                            id="radio-2"
                                                            name="radio"
                                                            type="radio"
                                                          ></input>
                                                          <label
                                                            for="radio-2"
                                                            class="radio-label"
                                                          >
                                                            Stor
                                                        </label>
                                                          <span className="addPrice">
                                                            {item.large_price}
                                                          </span>
                                                        </div>
                                                      </a>
                                                    ) : (
                                                        <></>
                                                      )}



                                                    {/**if there is only medium display medium and small*/}
                                                    {/** small*/}

                                                    {item.large_price == null ? (
                                                      <a
                                                        class="dropdown-item"
                                                        onClick={clickDropdownItem.bind(
                                                          this
                                                        )}
                                                      >
                                                        <div class="radio radio1">
                                                          <input
                                                            id="radio-1"
                                                            name="radio"
                                                            type="radio"
                                                          ></input>
                                                          <label
                                                            for="radio-1"
                                                            class="radio-label"
                                                          >
                                                            Standard
                                                        </label>
                                                          <span className="addPrice">
                                                            {item.price}
                                                          </span>
                                                        </div>
                                                      </a>
                                                    ) : (
                                                        <></>
                                                      )}
                                                    {/** medium*/}

                                                    {item.large_price == null ? (
                                                      <a
                                                        class="dropdown-item"
                                                        onClick={clickDropdownItem.bind(
                                                          this
                                                        )}
                                                      >
                                                        <div class="radio radio2">
                                                          <input
                                                            id="radio-2"
                                                            name="radio"
                                                            type="radio"
                                                          ></input>
                                                          <label
                                                            for="radio-2"
                                                            class="radio-label"
                                                          >
                                                            Mellan
                                                        </label>
                                                          <span className="addPrice">
                                                            {item.medium_price}
                                                          </span>
                                                        </div>
                                                      </a>
                                                    ) : (
                                                        <></>
                                                      )}



                                                    {item.large_price != null &&
                                                      item.medium_price != null ? (
                                                        <a
                                                          class="dropdown-item"
                                                          onClick={clickDropdownItem.bind(
                                                            this
                                                          )}
                                                        >
                                                          <div class="radio radio1">
                                                            <input
                                                              id="radio-1"
                                                              name="radio"
                                                              type="radio"
                                                            ></input>
                                                            <label
                                                              for="radio-1"
                                                              class="radio-label"
                                                            >
                                                              Standard
                                                        </label>
                                                            <span className="addPrice">
                                                              {item.price}
                                                            </span>
                                                          </div>
                                                        </a>

                                                      ) : (
                                                        <></>
                                                      )}

                                                    {item.large_price != null &&
                                                      item.medium_price != null ? (
                                                        <a
                                                          class="dropdown-item"
                                                          onClick={clickDropdownItem.bind(
                                                            this
                                                          )}
                                                        >
                                                          <div class="radio radio2">
                                                            <input
                                                              id="radio-2"
                                                              name="radio"
                                                              type="radio"
                                                            ></input>
                                                            <label
                                                              for="radio-2"
                                                              class="radio-label"
                                                            >
                                                              Mellan
                                                        </label>
                                                            <span className="addPrice">
                                                              {item.medium_price}
                                                            </span>
                                                          </div>
                                                        </a>
                                                      ) : (
                                                        <></>
                                                      )}

                                                    {item.large_price != null &&
                                                      item.medium_price != null ? (
                                                        <a
                                                          class="dropdown-item"
                                                          onClick={clickDropdownItem.bind(
                                                            this
                                                          )}
                                                        >
                                                          <div class="radio radio3">
                                                            <input
                                                              id="radio-3"
                                                              name="radio"
                                                              type="radio"
                                                            ></input>
                                                            <label
                                                              for="radio-3"
                                                              class="radio-label"
                                                            >
                                                              Stor
                                                        </label>
                                                            <span className="addPrice">
                                                              {item.large_price}
                                                            </span>
                                                          </div>
                                                        </a>
                                                      ) : (
                                                        <></>
                                                      )}



                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </div>

                                        <div className="column addButton">
                                          <button
                                            className="button is-danger"
                                            onClick={clickAddToCart.bind(this)}
                                          >
                                            <figure className="shoppingIcon">
                                              <img
                                                src={shoppingBag}
                                                alt="Shopping Bag"
                                              ></img>
                                            </figure>
                                            Lägg till
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                          <></>
                        )
                    )}
                  </div>
                ))}
              </div>

              <div className="column is-3 cart is-hidden-touch">
                <div className="container">
                  <div className="columns">
                    <div className="column cartColumn emptyCart">
                      <h1>Din varukorg</h1>
                      <figure>
                        <img src={cartImage} alt=""></img>
                      </figure>
                      <p>
                        Välj vilka rätter du vill beställa för att se här dessa
                        i varukorgen.
                      </p>
                    </div>

                    <div className="column cartColumn notEmptyCart">
                      <figure>
                        <img src={shoppingBasket} alt=""></img>
                        <h2>Din varukorg</h2>
                      </figure>
                      <div className="columns">
                        <div className="column is-12 addedItems"></div>
                      </div>
                      <div className="columns checkoutTotalColumns">
                        <div className="column is-6 has-text-left checkoutTotal foodTotal">
                          <p>Totalt:</p>
                        </div>
                        <div className="column is-6 has-text-right checkoutTotal">
                          <p>
                            <span></span><span> kr</span> 
                          </p>
                        </div>
                      </div>
                      <Link
                        onClick={goToCheckOutClick.bind(this)}
                        className="button is-danger checkoutButton"
                      >
                        Gå vidare
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="columns">
                    <div className="column is-5 has-text-right phone">
                      <figure>
                        <img src={phoneImage} alt="Phone Image"></img>
                      </figure>
                    </div>
                    <div className="column is-6 has-text-left number">
                      <p>Behöver du hjälp?</p>
                      <a href={`tel:+${this.state.restaurantPhone}`}>
                      <b>{this.state.restaurantPhone}</b>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="container findieContainer">
                  <div className="columns">
                    <div className="column findieColumn">
                      <figure>
                        <p>Levereras av Guestro AB</p>
                        <a className="guestro-btn" href="https://guestro.se/">
                          <img src={guestroLogo} alt="" />
                        </a>
                      </figure>
                      <a href="https://guestro.se/page/privacy-policy/">Privacy policy </a> •{" "}
                      <a href="https://guestro.se/page/privacy-policy/">Användarvillkor</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
